import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { useEffect, useState } from 'react';
import { EditableMissionState } from '../../mission/model/EditableMissionState';
import { MissionsState } from './MissionsState';
import { AlertPresenter } from '../../app/AlertBinder';
import { HistoryViewModel } from '../../app/HistoryViewModel';

export const useEditableMissionState = (missionId: string) => {

    const missions = useInstance(MissionsState);
    useSubscription(() => missions);

    const alert = useInstance(AlertPresenter);
    const history = useInstance(HistoryViewModel);

    const [mission, setMission] = useState<EditableMissionState>();

    useEffect(() => {
        missions.getMissionById(missionId).then(setMission)
            .catch((e: any) => {
                if (e.errorCode === 'mission.not-found') {
                    alert.showAlert({
                        header: 'Mission Not Found',
                        message: `Sorry, the mission you tried to view does not exist, or has been deleted.`
                    });
                    history.back('/missions');
                } else {
                    alert.showAndLogError(e);
                }
            });

    }, [missionId, missions, alert, history]);

    return mission;
};
